import { FC, useMemo } from 'react';

import { Formik, type FormikHelpers } from 'formik';
import {
  SIMPLE_DEAL_FORM,
  SIMPLE_DEAL_SCHEMA,
} from 'modules/account/sales/forms/schema';
import SimpleDealForm from 'modules/account/sales/forms/SimpleDealForm';
import { useCreateDeal, useGetPipelines } from 'modules/account/sales/hooks';
import { useTour } from '@reactour/tour';

import { ComponentToRenderGenericProps } from '../GlobalCreate';

const FORM_INIT: SIMPLE_DEAL_FORM = {
  name: '',
  amount: 0,
  type: '',
  accountUserId: [],
  pipelineId: '',
  stageId: '',
};

type DealProps = ComponentToRenderGenericProps;

const Deal: FC<DealProps> = ({ close }) => {
  const { isOpen } = useTour();
  const { mutate: createDeal, isLoading } = useCreateDeal();
  const { data: pipelines } = useGetPipelines();

  const selectedPipelineId = useMemo(() => {
    const primaryPipeline = pipelines?.find(
      (pipeline) => pipeline.isPrimary === true,
    );

    if (primaryPipeline) {
      return primaryPipeline._id;
    } else {
      return pipelines?.[0]._id;
    }
  }, [pipelines]);

  const onSubmit = (
    values: SIMPLE_DEAL_FORM,
    { setSubmitting }: FormikHelpers<SIMPLE_DEAL_FORM>,
  ) => {
    createDeal(values, {
      onSuccess: () => close(),
      onSettled: () => {
        setSubmitting(false);
      },
    });
  };

  return (
    <Formik<SIMPLE_DEAL_FORM>
      initialValues={{
        ...FORM_INIT,
        pipelineId: selectedPipelineId as string,
        ...(isOpen && { name: 'Test Deal' }),
        ...(isOpen && { amount: 5000 }),
        ...(isOpen && { type: 'NEW_BUSINESS' }),
      }}
      onSubmit={onSubmit}
      validationSchema={SIMPLE_DEAL_SCHEMA}
      enableReinitialize
    >
      {() => <SimpleDealForm isLoading={isLoading} onCancel={close} />}
    </Formik>
  );
};

export default Deal;
